import * as React from 'react'
import { FLAGS } from '@atbash-labs/ontology-flags'

import { useFlag } from '../../../components/flags/useFlag'
import { ingestSourcesHiddenByFlags } from './constants'
import type { SourceId } from './types'

export function useHiddenIngestSources(): ReadonlySet<SourceId> {
  const experion = useFlag(FLAGS.UI_INGEST_EXPERION)
  const srs = useFlag(FLAGS.UI_INGEST_SRS)
  const safetyManager = useFlag(FLAGS.UI_INGEST_SAFETY_MANAGER)
  const canary = useFlag(FLAGS.UI_INGEST_CANARY)
  return React.useMemo(
    () =>
      ingestSourcesHiddenByFlags({
        experion,
        srs,
        safetyManager,
        canary
      }),
    [experion, srs, safetyManager, canary]
  )
}
